
  export default {
    mounted() {
      if (!("serviceWorker" in navigator)) return
      navigator.serviceWorker.register("/sw.js").catch(() => {})
    }
  }
